/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import { isArray, set } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { t } from "i18next";
import PropTypes from "prop-types";
import { resetState } from "../../../../slices/formInitialSlice";

function DynamicSearchMenu({
  label,
  queryParam,
  loadingKey,
  dataKey,
  fetchAction,
  multiple = true, // إضافة multiple كـ prop افتراضي true
  withExpandButton = true, // إضافة withExpandButton كـ prop افتراضي true
  paramSelectName1 = "name",
  paramSelectName2 = null,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedItems, setSelectedItems] = useState([]);
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);
  const [debouncedInputValue, setDebouncedInputValue] = useState("");
  const [input, setInput] = useState("");

  const formReducer = useSelector((state) => state.form);
  const [mainData, setMainData] = useState([]);
  const isFirstFetch = useRef(true);

  useEffect(() => {
    return () => {
      dispatch(resetState()); // Reset form data on unmount
      setSelectedItems([]);
      setMainData([]);
      setInput("");
      setDebouncedInputValue("");
    };
  }, []);

  useEffect(() => {
    if (!queryParam) {
      return;
    }

    if (formReducer[loadingKey] === "succeeded") {
      const newData = formReducer[dataKey]?.["{}"]  || [];
      const addedList = newData.filter(
        (item2) => !mainData.some((item1) => item1.id === item2.id)
      );
      if (addedList.length) {
        setMainData((prevData) => [...prevData, ...addedList]);
      }
    }

    const searchParams = new URLSearchParams(location.search);
    const paramValue = searchParams.get(queryParam);

    if (isFirstFetch.current && formReducer[loadingKey] === "succeeded") {
      isFirstFetch.current = false;

      if (!multiple && !withExpandButton && !paramValue) {

               const selectedItem = parseInt(formReducer[dataKey]?.[0]?.id || []);


        setSelectedItems([selectedItem]);
          setInput(formReducer[dataKey]?.["{}"]?.[0]?.name || "");

         return;
      }

      if (paramValue === null) {
        setSelectedItems([]);
      } else {
        if (!multiple && !withExpandButton) {

          setSelectedItems([parseInt(paramValue)]);
          setInput( formReducer[dataKey]?.["{}"]?.find((item) => item.id === parseInt(paramValue))
            ? formReducer[dataKey]?.["{}"]?.find((item) => item.id === parseInt(paramValue))?.name
            : "None"
            );
        } else {
          const selectedTypes = paramValue.split(",").map(Number);
        setSelectedItems(selectedTypes);
        
        }
      }
    }

   
    // eslint-disable-next-line
  }, [formReducer[loadingKey], location.search]);

  useEffect(() => {

    updateURLQuery();
    // eslint-disable-next-line
  }, [selectedItems]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (fetchAction) {
        dispatch(fetchAction({ name: debouncedInputValue }));
      }
    }, 500);
    return () => clearTimeout(timeoutId);
    // eslint-disable-next-line
  }, [debouncedInputValue, fetchAction, dispatch]);

  const updateURLQuery = () => {
    if (anchor || (!withExpandButton &&  !multiple)) {
      const searchParams = new URLSearchParams(location.search);
      if (selectedItems.length === 0) {
        searchParams.delete(queryParam);
      } else {
        searchParams.set(queryParam, selectedItems.join(","));
      }
      navigate({ search: searchParams.toString() });
    }
  };

  const handleAutocompleteChange = (event, value) => {
    if (!withExpandButton) {
      setAnchor(event.currentTarget);
    }

    if (multiple) {
      setSelectedItems(value.map((item) => item.id));
    } else {
      setSelectedItems(value ? [value.id] : []);
      setInput(value ? value.name : "");
    }
  };

  const handleClick = (event) => {
    setAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setAnchor(null);
  };

  const AutocompleteComponent = (
    <Autocomplete
      multiple={multiple}
      fullWidth
      id={`${label}-autocomplete`}
      options={mainData}
      value={
        multiple
          ? selectedItems.map((id) =>
              isArray(mainData)
                ? mainData.find((item) => item.id === id) || null
                : []
            )
          : mainData.find((item) => item.id === selectedItems[0]) || null
      }
      onChange={handleAutocompleteChange}
      inputValue={input}
      onInputChange={(event, value, reason) => {
        if (reason === "input") setDebouncedInputValue(value);
      }}
      clearText="Clear"
      disableCloseOnSelect={multiple}
      getOptionLabel={(option) => option?.[paramSelectName1] + (paramSelectName2 && option?.[paramSelectName2] ? ` (${option?.[paramSelectName2]})` : "")}
      loading={formReducer[loadingKey] === "pending"}
      renderInput={(params) => (
        <TextField
          {...params}
          label={`#${t(label)}`}
          onChange={(e) => {
            setInput(e.target.value);
          }}
          sx={{ width: "100%" }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {formReducer[loadingKey] === "pending" ? (
                  <CircularProgress color="error" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );

  return (
    <Box className={`DynamicSearchMenu-${label}`}>
      {withExpandButton && (
        <Box>
          <Button
            id={label}
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            {t(label)}
            {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Button>

          <Menu
            id="basic-menu"
            anchorEl={anchor}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": label,
            }}
            PaperProps={{
              style: {
                width: "25%",
                maxWidth: "100%",
                maxHeight: "300px",
                left: 0,
                right: 0,
              },
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxHeight: "300px",
                overflow: "auto",
                p: 2,
              }}
            >
              {AutocompleteComponent}
            </Box>
          </Menu>
        </Box>
      )}

      {!withExpandButton && (
        <Box sx={{ width: "100%" }}>{AutocompleteComponent}</Box>
      )}
    </Box>
  );
}

DynamicSearchMenu.propTypes = {
  label: PropTypes.string.isRequired,
  queryParam: PropTypes.string.isRequired,
  loadingKey: PropTypes.string.isRequired,
  dataKey: PropTypes.string.isRequired,
  paramSelectName1: PropTypes.string,
  paramSelectName2: PropTypes.string,
  multiple: PropTypes.bool,
  withExpandButton: PropTypes.bool,
  fetchAction: PropTypes.func.isRequired,
};

export default DynamicSearchMenu;
